import { Draft, freeze, produce } from 'immer'
import { useCallback, useState } from 'react'

export const useImmer = <T>(initialValue: T) => {
  const [value, setValue] = useState<T>(() =>
    freeze(typeof initialValue === 'function' ? initialValue() : initialValue, true)
  )

  const immerSetValue = useCallback((updater: (draft: Draft<T>) => T) => {
    if (typeof updater === 'function') {
      setValue(produce<T>(updater))
    } else {
      setValue(freeze(updater))
    }
  }, [])

  return [value, immerSetValue] as const
}
